<script setup lang="ts">
import { computed } from "vue"
import { useShopAppConfig } from "@/shop/composables"
import RevokeOrderCustomerComponent from "@/shop/components/legal/RevokeOrderPage/RevokeOrderCustomerComponent.vue"
import RevokeOrderGuestComponent from "@/shop/components/legal/RevokeOrderPage/RevokeOrderGuestComponent.vue"

const { appConfig } = useShopAppConfig()

const isLoggedIn = computed(() => !!appConfig.value.user)
</script>

<template>
    <div class="container">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <div class="breadcrumb-item">Vertrag widerrufen</div>
        </div>
    </div>

    <div class="container mt-5">
        <h1>Vertrag widerrufen</h1>
    </div>

    <div class="container">
        <RevokeOrderGuestComponent v-if="!isLoggedIn" />
        <RevokeOrderCustomerComponent v-if="isLoggedIn" />
    </div>
</template>
